<template>
    <v-card :dark="customization.dark">
        <v-dialog v-model="dialog_remove" max-width="800px" :dark="customization.dark">
            <v-card>
                <v-card-title>Remover registro</v-card-title>
                <v-card-subtitle>Certeza que você quer remover esse registro? essa ação é irreversível!</v-card-subtitle>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog_remove = false">Cancelar</v-btn>
                    <v-btn color="red darken-1"  text @click="removeConfirm">Remover</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
            <v-card-title>
                <h2>{{label}}</h2>
                <v-spacer></v-spacer>
                <v-btn v-if="editable == true" color="green" text @click="create">
                    <v-icon>mdi-plus</v-icon> Incluir
                </v-btn>
            </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            loading-text="Carregando... Por favor espere"
            class="elevation-1"
            :items-per-page="10"
            :loading="loading"
        >
            <template v-slot:item="{ item, index }">
                <tr
                    :data-category-id="index"
                    :data-id="index"
                >   
                    <td
                        v-for="(i,ind) in headers.map(h=>{return h.value})"
                        :key="`${i}_${index}`"
                    >
                        <div v-if="headers.map(h=>{return h.value}).includes(i)">
                            <Autocomplete
                                v-if="headers[ind].type == 'autocomplete'"
                                :placeholder="headers[ind].text"
                                :required="headers[ind].required"
                                :modelEx="item[i]"
                                :dark="customization.dark"
                                :needWhere="headers[ind].autocomplete.needWhere"
                                :url="headers[ind].autocomplete.url"
                                :iddisplay="headers[ind].autocomplete.display"
                                :idvalue="headers[ind].autocomplete.value"
                                :disabled="!editable"
                                :value="item[i]"
                                :notOutline="true" 
                                :name="headers[ind].value"
                                :n="index"
                                v-on:change="autoCompleteChange">
                            </Autocomplete>
                            <v-switch 
                                v-else-if="headers[ind].type == 'check'"
                                :id="`check_${i}_${index}`"
                                v-model="checks[`${i}_${index}`]" 
                                class="ma-4" 
                                :disabled="!editable"
                                @change="setCheck(i,index)"
                            ></v-switch>
                            <span
                                v-else-if="!editable">
                                {{item[i]}}
                            </span>
                            <v-text-field
                                v-else-if="headers[ind].type == 'date'"
                                type="date"
                                v-model="item[i]"
                                :placeholder="headers[ind].text"
                                :rules="headers[ind].required ? requireRule : []">
                            </v-text-field>
                            <v-text-field
                                v-else-if="headers[ind].type == 'number'"
                                type="number"
                                v-model="item[i]"
                                :placeholder="headers[ind].text"
                                :rules="headers[ind].required ? requireRule : []">
                            </v-text-field>
                            <v-text-field
                                v-else-if="headers[ind].type == 'time'"
                                type="time"
                                v-model="item[i]"
                                :placeholder="headers[ind].text"
                                :rules="headers[ind].required ? requireRule : []">
                            </v-text-field>
                            <v-textarea
                                v-else-if="headers[ind].type == 'textarea'"
                                v-model="item[i]"
                                :placeholder="headers[ind].text"
                                :rules="headers[ind].required ? requireRule : []"
                            >
                            </v-textarea>
                            <v-select
                                v-else-if="headers[ind].type == 'select'"
                                v-model="item[i]"
                                :items="headers[ind].items"
                                :placeholder="headers[ind].text"
                                :rules="headers[ind].required ? requireRule : []">
                            </v-select>
                            <v-btn 
                                icon
                                @click="remove(index)"
                                v-else-if="headers[ind].type == 'action' && editable">
                                <v-icon>
                                    mdi-trash-can
                                </v-icon>
                            </v-btn>
                            <v-text-field
                                v-else
                                v-model="item[i]"
                                :placeholder="headers[ind].text"
                                :rules="headers[ind].required ? requireRule : []">
                            </v-text-field>
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <input type="hidden" :name="name" :value="itensJSON()" />
        <input type="hidden" :name="`${name}_removed`" :value="JSON.stringify(itemsRemoved)" />
    </v-card>
</template>

<script>
import Autocomplete from '@/components/Autocomplete.vue';
import api          from '@/plugins/apisauceHeader.js';

export default {
    props: ['customization','headers','editable','name','label','url','id_rel','id','id_grid','needClient'],
    name: 'Grid',
    components:{
        Autocomplete
    },
    data: () => ({
        search: "",
        rSearch: "",
        page: 1,
        cols: [],
        loading: false,
        selected: null,
        dialog_remove: false,
        items: [],
        itemsRemoved: [],
        checkList:{},
        requireRule:[
            r => (r && r.length > 0) || "Essa campo é obrigatório!"
        ],
        checks: {}
    }),
    methods: {
        setCheck(i,index){
            setTimeout(() => {
                const items = this.items;
                items[index][i] = document.getElementById(`check_${i}_${index}`).checked ? "1" : "0";
                this.items = items;
            }, 100);
        },
        getCheck(n){
            return n == "1" ? true : false;
        },
        itensJSON(){
            let items = this.items;

            items.forEach(i=>{
                if(this.needClient)
                    i['idcliente'] = localStorage.getItem("idcliente");
                
                Object.keys(i).forEach(k=>{
                    const ki = this.headers.map(h=>{return h.value}).indexOf(k);
                    if(ki != -1){
                        if(this.headers[ki].responsetype == "string") 
                            i[k] = `${i[k]}`;
                    }
                })
            })

            return JSON.stringify(items);
        },
        remove(i){
            this.selected = i;
            this.dialog_remove = true;
        },
        create(){
            const nItem = {};
        
            this.headers.forEach((h)=>{
                if(h.type == "check"){
                    this.checks[`${h.value}_${this.items.length}`] = false;
                    nItem[h.value] = "0";
                    this.setCheck(h.value,this.items.length);
                } else
                if(h.value != "action")
                    nItem[h.value] = "";
            });

            this.items.push(nItem);
        },
        removeConfirm(){
            if(this.items[this.selected][this.id_grid]) this.itemsRemoved.push(this.items[this.selected][this.id_grid]);

            this.items.splice(this.selected,1);
            const itens = JSON.stringify(this.items);
            const vue = this;
            this.items = [];
            setTimeout(() => {
                vue.items = JSON.parse(itens);
            }, 500);

            this.selected = null;
            this.dialog_remove = false;
        },
        autoCompleteChange(v){
            this.items[v.n][v.name] = v.value;
            if(v.unidade)
                this.items[v.n]['unidade'] = v.unidade;
        }
    },
    mounted(){
        this.cols = Object.keys(this.headers);
        if(!this.headers.map(h=>{return h.value}).includes("action") && this.editable)
            this.headers.push(
            { 
                "text": "Remover", 
                "value": "action", 
                "type": "action",
                "sortable": false
            });

        if(this.url){
            this.loading = true;
            api(localStorage.getItem("token")).get(`endpoint/${this.url}/addwhere=${this.id_rel}:${this.id}`).then(r=>{
                if(r.ok){
                    let items = r.data.endpoint.map(i=>{
                        return {...i,...{
                            "idmotorista_grid": i['idmotorista']
                        }}
                    });
                    this.items = items;

                    const checks = {};
                    this.items.forEach((i,index)=>{
                        this.headers.forEach(h=>{
                            if(h.type == "check"){
                                checks[`${h.value}_${index}`] = i[h.value];
                                this.setCheck(h.value,index);
                            }
                        })
                    })
                    this.checks = checks;
                }
                this.loading = false;
            })
        }
    }
}
</script>